import {select2Init} from "../functions/select2Init";

const auditAdd = () => {

    $(() => {

        select2Init('select[data-select=select2]')

    })

}

window.initAuditAdd = () => {
    auditAdd()
}